var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9312 24.5C47.9541 24.5 47.9771 24.4982 48 24.4982L47.8641 24.4982C24.0026 24.4065 23.9991 0.5 23.9991 0.5C23.9991 0.5 23.9974 24.4065 0.135857 24.4982H0C0.022937 24.4982 0.0458739 24.5 0.0688109 24.5C0.0458739 24.5 0.022937 24.5018 0 24.5018H0.135857C23.9974 24.5935 23.9991 48.5 23.9991 48.5C23.9991 48.5 24.0009 24.5935 47.8624 24.5018H47.9982C47.9771 24.5 47.9541 24.5 47.9312 24.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStar);
export default __webpack_public_path__ + "static/media/blackStar.97b3a7b5a5abd10a9e08afac88120b65.svg";
export { ForwardRef as ReactComponent };